import { connect } from 'react-redux'
import * as actions from '../LoggedIn/actions'
import { recieveLoginstatus } from '../../routes/Login/actions'
import Layout from './Layout'

const mapStateToProps = (state, ownProps) => {
  return {
    isCheckingUser: state.loginLayout.isCheckingUser,
    isCheckingToken: state.loginLayout.isCheckingToken,
    user: state.loginLayout.user,
    userExists: state.loginLayout.userExists,
    shouldRedirect: state.loginLayout.shouldRedirect,
    tokenVerified: state.loginLayout.tokenVerified,
    isLoggedIn: state.login.isLoggedIn
  }
}

const mapDispatchToProps = dispatch => ({
  returnUserIfUserExists: token =>
    dispatch(actions.returnUserIfUserExists(token)),
  checkValidity: token => dispatch(actions.checkValidity(token)),
  checkTokenOnPathChange: token =>
    dispatch(actions.checkTokenOnPathChange(token)),
  shouldRedirectUser: bool => dispatch(actions.shouldRedirectUser(bool)),
  recieveLoginstatus: (bool, user) => dispatch(recieveLoginstatus(bool, user))
})

const LoggedOutLayoutContainer = connect(mapStateToProps, mapDispatchToProps)(
  Layout
)

export default LoggedOutLayoutContainer



// WEBPACK FOOTER //
// src/layouts/LoggedOut/LoggedOutLayoutContainer.js